import { SVGProps } from 'react'

export const MessageNotify = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <rect width="16" height="16" fill="#3A79E0" rx="4"></rect>
    <path
      fill="#fff"
      d="M12 3H4c-.55 0-.995.45-.995 1L3 13l2-2h7c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-1.5 6h-5a.501.501 0 01-.5-.5c0-.275.225-.5.5-.5h5c.275 0 .5.225.5.5s-.225.5-.5.5zm0-1.5h-5A.501.501 0 015 7c0-.275.225-.5.5-.5h5c.275 0 .5.225.5.5s-.225.5-.5.5zm0-1.5h-5a.501.501 0 01-.5-.5c0-.275.225-.5.5-.5h5c.275 0 .5.225.5.5s-.225.5-.5.5z"
    ></path>
  </svg>
)
